import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";

// Route-level code splitting: only the homepage ships in the initial bundle.
// All secondary pages load on demand to keep the LCP route's JS minimal.
const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const SeoLandingPage = lazy(() => import("./pages/SeoLandingPage.tsx"));
const SeoLandingPageUz = lazy(() => import("./pages/SeoLandingPageUz.tsx"));
const UzContact = lazy(() => import("./pages/UzContact.tsx"));
const Blog = lazy(() => import("./pages/Blog.tsx"));
const BlogPost = lazy(() => import("./pages/BlogPost.tsx"));
const Catalog = lazy(() => import("./pages/Catalog.tsx"));
const Dealers = lazy(() => import("./pages/Dealers.tsx"));
const Admin = lazy(() => import("./pages/Admin.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            {/* SEO landing pages (RU) */}
            <Route path="/zhalyuzi-den-noch-tashkent" element={<SeoLandingPage />} />
            <Route path="/rulonnye-shtory-tashkent" element={<SeoLandingPage />} />
            <Route path="/plisse-tashkent" element={<SeoLandingPage />} />
            <Route path="/moskitnye-setki-tashkent" element={<SeoLandingPage />} />
            <Route path="/setka-plisse-tashkent" element={<SeoLandingPage />} />
            <Route path="/shtory-dlya-vannoy-tashkent" element={<SeoLandingPage />} />
            <Route path="/zhalyuzi-tashkent-cena" element={<SeoLandingPage />} />
            <Route path="/zamer-zhalyuzi-besplatno-tashkent" element={<SeoLandingPage />} />
            <Route path="/rolstavni-tashkent" element={<SeoLandingPage />} />
            {/* District landings */}
            <Route path="/zhalyuzi-chilanzar" element={<SeoLandingPage />} />
            <Route path="/zhalyuzi-yunusabad" element={<SeoLandingPage />} />
            <Route path="/zhalyuzi-mirzo-ulugbek" element={<SeoLandingPage />} />
            <Route path="/zhalyuzi-sergeli" element={<SeoLandingPage />} />
            <Route path="/zhalyuzi-yakkasaray" element={<SeoLandingPage />} />
            <Route path="/zhalyuzi-shaykhantaur" element={<SeoLandingPage />} />
            <Route path="/zhalyuzi-uchtepa" element={<SeoLandingPage />} />
            <Route path="/zhalyuzi-almazar" element={<SeoLandingPage />} />
            <Route path="/zhalyuzi-bektemir" element={<SeoLandingPage />} />
            <Route path="/zhalyuzi-yashnabad" element={<SeoLandingPage />} />
            <Route path="/zhalyuzi-kibray" element={<SeoLandingPage />} />
            {/* Uzbek-language pages */}
            <Route path="/uz/aloqa" element={<UzContact />} />
            <Route path="/uz/:slug" element={<SeoLandingPageUz />} />
            {/* Blog */}
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/dileram" element={<Dealers />} />
            <Route path="/admin" element={<Admin />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
